import {Map, fromJS, List} from "immutable";

import {
    GET_ALERT_TYPES_SUCCESS,
    GET_ALERT_TYPES_REQUEST,
    GET_ALERT_TYPES_ERROR,

    UPDATE_ALERT_TYPE_REQUEST,
    UPDATE_ALERT_TYPE_SUCCESS,
    UPDATE_ALERT_TYPE_ERROR,

    CLEAN_ALERT_TYPES
} from '../actions/alert-types';

const alertTypes = (state = Map({
  payload: List([]),
  isFetching: false,
  error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_ALERT_TYPES_REQUEST:
      case UPDATE_ALERT_TYPE_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Success
      case GET_ALERT_TYPES_SUCCESS:
      case CLEAN_ALERT_TYPES:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case UPDATE_ALERT_TYPE_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              if (action.payload.length > 1) {
                  updatedPayload = payload;
                  action.payload.forEach( actionPayload => {
                      // Find the index of the work-report to be updated inside the List
                      index = updatedPayload.findIndex(item => {
                          return item.get('_id') === actionPayload._id;
                      });

                      // Update the payload list
                      if (index !== -1) {
                          updatedPayload = updatedPayload.update(index, () => {
                              return fromJS(actionPayload);
                          });
                      }
                  });
              } else {
                  // Find the index of the work-report to be updated inside the List
                  index = payload.findIndex(item => {
                      return item.get('_id') === action.payload._id;
                  });
                  // Update the payload list
                  if (index !== -1) {
                      updatedPayload = payload.update(index, () => {
                          return fromJS(action.payload);
                      });
                  }
              }
              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(state.get('payload'))) {
              updatedPayload = fromJS(action.payload);
          }
          newState = state
              .merge({
                  isFetching: action.isFetching,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;

      // Errors
      case GET_ALERT_TYPES_ERROR:
      case UPDATE_ALERT_TYPE_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default alertTypes;



// WEBPACK FOOTER //
// ./src/reducers/alert-types.js